import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ConversationList = ({ conversations, selectedConversation, onSelectConversation }) => {
  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date?.toLocaleDateString();
  };

  const getStatusColor = (status) => {
    const colors = {
      available: 'bg-success',
      busy: 'bg-warning',
      offline: 'bg-muted'
    };
    return colors?.[status] || 'bg-muted';
  };

  return (
    <div className="divide-y divide-border">
      {conversations?.length === 0 ? (
        <div className="p-6 text-center text-muted-foreground">
          <Icon name="MessageSquare" size={48} className="mx-auto mb-3 opacity-50" />
          <p className="text-sm">No conversations yet</p>
          <p className="text-xs mt-1">Start a new chat to begin</p>
        </div>
      ) : (
        conversations?.map((conversation) => (
          <button
            key={conversation?.id}
            onClick={() => onSelectConversation?.(conversation)}
            className={cn(
              'w-full p-4 text-left hover:bg-muted/50 transition-colors',
              selectedConversation?.id === conversation?.id && 'bg-muted'
            )}
          >
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                <Icon name="Bot" size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="font-medium text-foreground truncate">
                    {conversation?.agent?.name}
                  </h4>
                  <span className="text-xs text-muted-foreground flex-shrink-0 ml-2">
                    {formatTime(conversation?.lastMessageAt)}
                  </span>
                </div>
                <div className="flex items-center gap-2 mb-1">
                  <span className={cn(
                    'w-1.5 h-1.5 rounded-full',
                    getStatusColor(conversation?.agent?.status)
                  )}></span>
                  <span className="text-xs text-muted-foreground capitalize">
                    {conversation?.agent?.status}
                  </span>
                </div>
                {conversation?.project && (
                  <div className="flex items-center gap-1 mt-1">
                    <Icon name="FolderTree" size={12} className="text-muted-foreground" />
                    <span className="text-xs text-muted-foreground truncate">
                      {conversation?.project?.name}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </button>
        ))
      )}
    </div>
  );
};

export default ConversationList;